// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"28ba8771","528":"06f877ae","529":"8004cc84","709":"25b367da","819":"510cbc5c","913":"a76582d3"}[chunkId] + ".chunk.js";
};